import { inject } from '@angular/core';
import { Router, type CanActivateFn } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { of } from 'rxjs';
import { map, take, filter, timeout, switchMap, catchError } from 'rxjs/operators';

export const lenderGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);
  const authService = inject(AuthService);

  return authService.currentUser$.pipe(
    filter(user => user !== null),
    take(1),
    timeout(10000),
    switchMap(() => authService.customClaims$.pipe(
      take(1),
      timeout(5000)
    )),
    map(claims => {
      const isLender = claims?.roles?.includes('lender') ?? false;
      const isAdmin = claims?.roles?.includes('admin') ?? false;
      if (isLender || isAdmin) {
        return true;
      }
      router.navigate(['/']);
      return false;
    }),
    catchError(error => {
      console.error('Lender guard: Error checking access:', error);
      router.navigate(['/']);
      return of(false);
    })
  );
};
